import Axios from "../../axios";
import { ApiResponse } from "../../apiResponse";
import { ApiCommonParams } from "../../@types/apiTypes";
import { commonApiParamsToApiParams } from "../../helpers/paramsHelpers";

export function indexSessions(
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get(`v1/supervisors/sessions`, { params });
}
export function indexLiveSessions(
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get(`v1/supervisors/sessions/live_sessions`, { params });
}
export function indexRequests(
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get(`v1/supervisors/requests_views`, { params });
}
export function indexRequestWithId(
  id: number | string,
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get(`v1/supervisors/schedule_requests/${id}`, { params });
}
export function indexCancellationRequestWithId(
  id: number | string,
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get(`v1/supervisors/cancellations/${id}`, { params });
}
export function setAsSeenSession(body: object): Promise<ApiResponse> {
  return Axios.post(`v1/supervisors/sessions/set_as_seen`, body);
}
export function getSessionData(
  id: string | number,
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get(`v1/supervisors/sessions/${id}`, { params });
}
export function getSessionCommentsData(
  id: string | number,
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get(`v1/supervisors/sessions/${id}/comments`, { params });
}
export function addSessionCommentData(
  id: string | number,
  data: string,
  isVisible: boolean
): Promise<ApiResponse> {
  console.log(data);
  return Axios.post(`v1/supervisors/sessions/${id}/comments`, {
    body: data,
    is_visible: isVisible,
  });
}
export function deleteSessionCommentData(
  sessionId: string | number,
  commentId: string | number
): Promise<ApiResponse> {
  return Axios.delete(
    `v1/supervisors/sessions/${sessionId}/comments/${commentId}`
  );
}
export function reportSession(
  sessionId: string | number,
  data: object
): Promise<ApiResponse> {
  return Axios.post(
    `/v1/supervisors/sessions/${sessionId}/abuse_reports`,
    data
  );
}
